import { resetPassword } from '@authentication/services/authServices';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import ResetPasswordRequestDto from '@authentication/models/reset-password.request.dto';

const useResetPasswordMutation = (): UseMutationResult<
  AxiosResponse<null>,
  unknown,
  { data: ResetPasswordRequestDto; token: string },
  unknown
> => {
  const resetPasswordMutation = useMutation({
    mutationFn: resetPassword,
  });

  return resetPasswordMutation;
};
export default useResetPasswordMutation;
